<label class="switch switch-disabled" [style.scale]="scale">
  @if (!locked) {
    <input type="checkbox" [formControl]="toggleInput" [disabled]="toggleInput.disabled">
  }
  <span
    class="slider round flex-center"
    [class.slider-accent]="color === 'accent'"
    [class.slider-accent-secondary]="color === 'accent-secondary'"
    [ngClass]="{ 'toggle-disabled': toggleInput.disabled || locked }"
    >
    <span class="knob" [ngClass]="{ 'locked': locked || toggleInput.disabled, 'unlocked': !locked }"></span>
  </span>
</label>
